"use client";

import { IZapierForm } from "@/sanity/globals/ZapierForm";

export interface ZapierFormData {
	url: string;
	data: {
		[key: string]: string;
	};
}

export async function submitFormDataToZapier(
	fieldData: any,
	formData: IZapierForm,
) {
	let fields: { [key: string]: string } = {};

  Object.entries(fieldData).forEach(([key, value]) => {
    fields[key] = value as string;
  });

  const data: ZapierFormData = {
    url: formData.settings.url,
    data: fields,
    // data: {
    // 	name: fieldData?.["firstName"] ?? fieldData?.["name"],
    // 	email: fieldData?.["email"],
    // 	phone: fieldData?.["phone"],
    // },
  };

	try {
		// no-cors not work with Axios
		await fetch(data.url, {
			method: "POST",
			mode: "no-cors",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(data.data),
		});

		return {
			success: true,
			message: "Form submitted successfully",
			submission: null,
		};
	} catch (e) {
		console.log(e);
		return {
			success: false,
			message: "Form submission failed",
		};
	}
}
